/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropXTweetResponse
 */
export interface DropXTweetResponse {
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    authorHandle: string;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    authorDisplayName: string;
    /**
     * 
     * @type {number}
     * @memberof DropXTweetResponse
     */
    favoriteCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DropXTweetResponse
     */
    retweetCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    photoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DropXTweetResponse
     */
    coverImageProxyUrl?: string | null;
}

/**
 * Check if a given object implements the DropXTweetResponse interface.
 */
export function instanceOfDropXTweetResponse(value: object): value is DropXTweetResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('authorHandle' in value) || value['authorHandle'] === undefined) return false;
    if (!('authorDisplayName' in value) || value['authorDisplayName'] === undefined) return false;
    return true;
}

export function DropXTweetResponseFromJSON(json: any): DropXTweetResponse {
    return DropXTweetResponseFromJSONTyped(json, false);
}

export function DropXTweetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropXTweetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'text': json['text'],
        'createdAt': json['createdAt'],
        'authorHandle': json['authorHandle'],
        'authorDisplayName': json['authorDisplayName'],
        'favoriteCount': json['favoriteCount'] == null ? undefined : json['favoriteCount'],
        'retweetCount': json['retweetCount'] == null ? undefined : json['retweetCount'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'coverImageProxyUrl': json['coverImageProxyUrl'] == null ? undefined : json['coverImageProxyUrl'],
    };
}

export function DropXTweetResponseToJSON(json: any): DropXTweetResponse {
    return DropXTweetResponseToJSONTyped(json, false);
}

export function DropXTweetResponseToJSONTyped(value?: DropXTweetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'text': value['text'],
        'createdAt': value['createdAt'],
        'authorHandle': value['authorHandle'],
        'authorDisplayName': value['authorDisplayName'],
        'favoriteCount': value['favoriteCount'],
        'retweetCount': value['retweetCount'],
        'photoUrl': value['photoUrl'],
        'coverImageProxyUrl': value['coverImageProxyUrl'],
    };
}

